//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/Builder.js";
import "../Motion/Motion.SelectFlexBody.js";
import "../no/ExternalFileReferenceAdapter.js";
import "../no/SelectObject.js";
let d=[[[1,"FlexBody",0,"Motion.SelectFlexBody",0],[0,"Name",1,0]],[[["modeNum","frequency"],"SetModeFrequencyMap",{},2,0],[[],"ClearModeFrequencyMap",{},0,0],[["flexBodyTag"],"CreateInputModesList",{},1,0],[[],"ClearInputModesList",{},0,0],[["modeNumber","inputFrequency"],"SetNthInputMode",{},2,0],[["flexBodyTag"],"CreateOriginModesList",{},1,0],[[],"ClearOriginModesList",{},0,0],[["referenceObjectId"],"GetExternalFileReferenceAdapter",{R_:{adapter:"ExternalFileReferenceAdapter"}},1,0],[["referenceObjectId","adapter"],"SetExternalFileReferenceAdapter",{},2,0],[["adapter"],"GetExternalFileDefinitionKey",{R_:{externalFileDefinitionKey:''}},1,0],[["referenceObjectId","referenceType","externalFileSpec"],"EstablishReference",{R_:{adapter:"ExternalFileReferenceAdapter"}},3,0]],[]];
SPLM.Motion.FlexModalContentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.FlexModalContentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;